<template>
  <v-container class="pedidos">
    <v-container>
      <v-card
        class="py-4 px-2 auth-content"
        tile
      >
        <v-form>
          <PageTitle
            icon="mdi-pencil-box-outline"
            main="Sic & Ouvidoria"
            sub="Cadastro de pedidos de informação"
            home="/home-sic"
          />
          <input
            id="user-id"
            type="hidden"
            v-model="pedido.usuario"
          />
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="pedido.id"
                label="Código do pedido"
                dense
                outlined
                @change="loadPedido()"
              >
                <v-btn
                  class="btn-outer-right pa-0"
                  slot="append"
                  color="success"
                  tile
                  @click.prevent="loadDialog"
                >
                  <v-icon
                    class="mx-0"
                    color="white"
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
                <!-- <v-icon
                  slot="append"
                  color="success"
                  large
                  @click="loadDialog"
                >
                  mdi-magnify
                </v-icon> -->
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
              v-if="codigo"
            >
              <v-text-field
                v-model="pedido.protocolo"
                label="Nº do protocolo"
                type="text"
                readonly
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-if="codigo"
            >
              <v-text-field
                v-model="pedido.situacao"
                readonly
                dense
                outlined
                label="Situação atual do processo"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-if="codigo"
            >
              <v-autocomplete
                v-model="pedido.tipo_resposta"
                :items="respostas"
                readonly
                dense
                outlined
                label="Tipo de resposta"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="3"
              lg="2"
            >
              <v-text-field
                class="codigo mr-0"
                v-model="pedido.uid_pessoa"
                label="Código..."
                :readonly="blokData"
                dense
                outlined
                flat
                @change="loadPessoaSel()"
              >
                <v-btn
                  class="btn-outer pa-0"
                  slot="append"
                  color="success"
                  tile
                  @click="loadFtPessoa"
                >
                  <v-icon
                    class="mx-0"
                    color="white"
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
                <v-btn
                  class="btn-outer-right pa-0"
                  slot="append"
                  color="light"
                  tile
                  @click="loadAddPessoa"
                >
                  <v-icon
                    class="mx-0"
                    color="black"
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-autocomplete
                v-if="!codepessoa"
                v-model="filtros"
                :items="items"
                :search-input.sync="ftpessoa"
                cache-items
                dense
                outlined
                hide-no-data
                hide-details
                label="Autor ou interessado"
                class="ml-n6"
                @change="loadPessoaSel()"
              >
              </v-autocomplete>
              <v-text-field
                v-if="codepessoa"
                v-model="pedido.solicitante"
                :readonly="blokData"
                class="ml-n6"
                outlined
                dense
                label="Nome do Solicitante"
                aria-labelledby="nome do solicitante"
                >
                  <v-icon
                    :disabled="blokData"
                    slot="append"
                    color="black"
                    @click="clPessoa"
                  >
                    mdi-close
                  </v-icon>
                </v-text-field>
            </v-col>
          </v-row>
          <v-card flat class="mt-2">
            <v-card
              color="grey lighten-5"
              elevation="2"
            >
              <v-tabs
                background-color="transparent"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
                color="primary"
                v-model="tabs"
              >
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab @click="activeBtn" class="mx-6">
                  Dados do pedido
                </v-tab>
                <v-tab
                  :disabled="btnAction != 'analisando'"
                  @click="loadTbHidtorico"
                  class="mx-6"
                >
                  <v-icon class="mr-1">
                    mdi-history
                  </v-icon>
                  Histórico
                </v-tab>
                <v-tab
                  :disabled="btnAction != 'analisando'"
                  @click="loadTbAnexo"
                >
                  <v-icon class="mr-1">
                    mdi-paperclip
                  </v-icon>
                  Anexos
                </v-tab>
                <v-tab
                  :disabled="btnAction != 'analisando'"
                  @click="loadResposta"
                >
                  <v-icon class="mr-1">
                    mdi-forum
                  </v-icon>
                  Responder
                </v-tab>
                <v-tab
                  :disabled="btnAction != 'analisando'"
                  @click="loadFinalizar"
                >
                  <v-icon class="mr-1">
                    mdi-message-text-lock-outline
                  </v-icon>
                  Encerrar
                </v-tab>
                <v-tab
                  readonly
                >
                  <v-icon class="mr-1">
                    mdi-message-text-lock-outline
                  </v-icon>
                  Prazo
                </v-tab>
                <v-tab
                  readonly
                >
                  <v-icon class="mr-1">
                    mdi-message-text-lock-outline
                  </v-icon>
                  Recursos
                </v-tab>
                <v-tab>
                  <v-icon class="mr-1">
                    mdi-message-text-lock-outline
                  </v-icon>
                  Mais inf.
                </v-tab>
              </v-tabs>
            </v-card>
            <hr />
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card class="mt-8">
                  <!--Informações gerais do pedido-->
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-autocomplete
                        v-model="pedido.uid_categoria"
                        :readonly="blokData"
                        :items="categorias"
                        :clearable="!blokData"
                        outlined
                        dense
                        label="Módulo do pedido"
                        @change="loadTpSolicitacoes()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        :readonly="!pedido.uid_categoria || blokData"
                        v-model="pedido.uid_tipo_solicitacao"
                        :items="solicitacoes"
                        :clearable="!blokData"
                        outlined
                        dense
                        label="Tipo de solicitação"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="pedido.uid_orgao"
                        :readonly="blokData"
                        :items="orgaos"
                        :clearable="!blokData"
                        outlined
                        dense
                        label="Órgão do pedido"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      lg="2"
                    >
                      <v-autocomplete
                        v-model="pedido.uid_veiculo"
                        :readonly="blokData"
                        :items="veiculos"
                        :clearable="!blokData"
                        outlined
                        dense
                        label="Veículo de comunicação"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      lg="10"
                    >
                      <v-textarea
                        v-model="pedido.pedido"
                        label="Descrição do pedido"
                        :readonly="blokData"
                        rows="3"
                        outlined
                        dense
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      lg="10"
                    >
                      <v-text-field
                        v-model="pedido.local"
                        label="Localização e outros"
                        type="text"
                        :readonly="blokData"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-textarea
                          v-model="pedido.observacao"
                          label="Observações"
                          type="text"
                          rows="3"
                          outlined
                          dense
                        >
                        </v-textarea>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Informações sobre o andamento do pedido
                        </v-card-text>
                        <v-data-table
                          :headers="headersHistorico"
                          :items="historicos"
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadHistorico(item ,'updateF')"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                            <v-icon
                              medium
                              color="error"
                              class="mr-2"
                              @click="loadImprimir(item)"
                            >
                              mdi-printer
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                            class="mb-2"
                          >
                            <v-btn
                              color="indigo"
                              dark
                              class="ml-4"
                              v-if="pedido.id"
                              @click="loadAddHistorico"
                            >
                              <v-icon left>
                                mdi-history
                              </v-icon>
                              Adicionar histórico
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Fotos e documentos
                        </v-card-text>
                        <v-data-table
                          :headers="headersAnexo"
                          :items="anexos"
                          item-key="id"
                          :search="search"
                          dense
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadAnexo(item)"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-btn
                              color="success"
                              class="ml-4"
                              v-if="codigo"
                              @click="loadAddAnexo"
                            >
                              <v-icon left>
                                mdi-paperclip
                              </v-icon>
                              Adicionar anexo
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Informações da resposta do pedido
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                        <v-textarea
                          v-model="pedido.resposta"
                          label="Descrição da resposta"
                          type="text"
                          outlined
                          dense
                        >
                        </v-textarea>
                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="menu0"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-mask="dta"
                                  v-model="data_resp"
                                  label="Data de resposta.:"
                                  dense
                                  outlined
                                  @blur="mudaDataA"
                                >
                                  <v-icon
                                    slot="append"
                                    color="success"
                                    large
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker
                                locale="pt-br"
                                v-model="date0"
                                @input="DateA"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            v-if="mode === 'responder'"
                          >
                            <v-checkbox
                              class="pt-0"
                              v-model="pedido.respondido"
                              label="Marcar como respondido?"
                              color="success"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              color="success"
                              class="mr-4"
                              v-if="respondido === false"
                              @click="addResposta()"
                            >
                              <v-icon left>
                                mdi-forum
                              </v-icon>
                              Responder
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Finalizar pedido
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-checkbox
                              v-model="pedido.concluido"
                              label="Concluir pedido?"
                              color="success"
                              @change="loadConclusao"
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            v-if="pedido.concluido"
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-mask="dta1"
                                  v-model="data_conc"
                                  label="Data de conclusao :"
                                  dense
                                  outlined
                                  @blur="mudaDataB"
                                >
                                  <v-icon
                                    slot="append"
                                    color="success"
                                    large
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker
                                locale="pt-br"
                                v-model="date1"
                                @input="DateB"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            v-if="pedido.concluido"
                            cols="12"
                            md="4"
                          >
                            <v-autocomplete
                              v-model="pedido.uid_situacao"
                              :items="statusEnd"
                              outlined
                              dense
                              label="Situação do processo"
                              @change="loadSaveStatus"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-btn
                        color="success"
                        class="mr-4"
                        v-if="finalizado === false"
                        @click="addFinalizar()"
                      >
                        <v-icon left>
                          mdi-message-text-lock-outline
                        </v-icon>
                        Encerrar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Em construção
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="2">
                      <!-- Dados aqui-->
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Em construção
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="2">
                      <!-- Dados aqui-->
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Configurações e outros
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="2"
                      v-if="codigo"
                    >
                      <v-checkbox
                        :readonly="blokData"
                        v-model="pedido.inativar"
                        label="Inativar Pedido?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-form>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            class="mr-4"
            v-if="btnAction === 'analisar'"
            @click="addEmAnalise()"
          >
            <v-icon left>
              mdi-magnify-scan
            </v-icon>
            Enviar para análise
          </v-btn>
          <v-btn
            color="indigo"
            dark
            class="mr-4"
            v-if="btnImprimir === 'imprimir'"
            :href="urlRel"
            target="_blank"
          >
            <v-icon left>
              mdi-printer
            </v-icon>
            Impimir
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            v-if="!codigo"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            v-if="codigo && btnUpdate == true"
            @click="updateObs"
          >
            <v-icon left>
              mdi-note-edit
            </v-icon>
            Atualizar observação
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            v-if="mode === 'edit'"
            @click="save"
          >
            <v-icon left>
              mdi-note-edit
            </v-icon>
            Atualizar
          </v-btn>
          <v-btn
            color="teal"
            dark
            class="mr-4"
            v-if="btnAction === 'enviar'"
            @click="EnviaPAnalise()"
          >
            <v-icon left>
              mdi-arrow-up-bold
            </v-icon>
            Eviar p/ analise
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar pedidos de Informação
              </v-toolbar>
              <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headersFt"
                :items="filtro"
                :search="search"
                dense
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click="loadPedidoFilter(item, 'edit')"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    large
                    color="error"
                    class="mr-2"
                    @click="loadPedidoFilter(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-dialog
          v-model="dialogPessoa"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar pessoas cadastradas
              </v-toolbar>
              <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar..."
                    single-line
                    hide-details
                  ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headersFtPessoa"
                :items="pessoas"
                :search="search"
                dense
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadPessoaId(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-card>
    </v-container>
    <v-container>
      <v-dialog
        v-model="addHistorico"
        transition="dialog-top-transition"
        max-width="1280"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
            <v-card-sub-title>
              <v-icon>mdi-pencil-box-outline</v-icon>
              Atualização do histórico do pedido
            </v-card-sub-title>
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="historico.usuario"
                />
                <input
                  id="historico-id"
                  type="hidden"
                  v-model="historico.id"
                />
                <input
                  id="historico-uid-pedido"
                  type="hidden"
                  v-model="historico.uid_pedido"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <v-textarea
                      v-model="historico.ds_historico"
                      label="Descrição do histórico"
                      type="text"
                      required
                      dense
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="7"
                  >
                    <v-autocomplete
                      v-model="historico.movimentacao"
                      :items="movimentacao"
                      required
                      clearable
                      outlined
                      dense
                      label="Situação do processo"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-checkbox
                      v-model="historico.chat"
                      label="Abrir chat de resposta?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="modef === 'savef'"
                type="submit"
                @click="adicionarHistoricoSave"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="modef === 'savef'"
                type="submit"
                @click="adicionarHistoricoSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="modef === 'updateF'"
                type="submit"
                @click="saveHistorico"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="modef === 'savef'"
                @click="limparHistorico"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="modef === 'removef'"
                type="submit"
                @click="removeF"
              >
                <v-icon left>
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="dialog.value = false"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container class="px-5">
      <v-dialog
        v-model="DialogAnexo"
        transition="dialog-top-transition"
      >
        <template v-slot:default>
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto ml-4 mt-5">
              <v-form
                v-model="valid"
                ref="form"
                class="altura"
              >
                <PageTitle
                  v-if="anexo.id"
                  icon="mdi-pencil-box-outline"
                  :sub="`Anexo (${anexo.nome})`"
                />
                <PageTitle
                  v-else
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar anexo"
                />
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <input
                  id="anexo-uuid"
                  type="hidden"
                  v-model="anexo.uuid"
                />
                <input
                  id="uid_pedido"
                  type="hidden"
                  v-model="anexo.uid_beneficio"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-autocomplete
                      v-model="anexo.tipo"
                      :items="tipo"
                      required
                      clearable
                      outlined
                      dense
                      label="Tipo de arquivo"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="btnDisable"
                  >
                    <v-checkbox
                      v-model="anexo.inativar"
                      label="Inativar anexo?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="anexo.nome"
                      type="text"
                      label="Nome do arquivo"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="mode === 'edit'">
                  <v-col cols="12" md="10" lg="10">
                    <v-text-field
                      v-if="!fileNovo"
                      :value="urlAnexo"
                      label="Arquivo atual"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-file"
                      hint="Arquivo atual anexado"
                      persistent-hint
                    >
                      <template v-slot:append>
                        <div class="botao-container">
                          <v-btn icon small @click="baixarArquivo()">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>

                          <v-btn icon small @click="abrirInputTroca()">
                            <v-icon>mdi-file-replace</v-icon>
                          </v-btn>

                          <v-btn icon small color="red" @click="confirmRemove()">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                    <input
                      v-show="fileNovo"
                      type="file"
                      ref="fileTroca"
                      v-if="uploadReady"
                      dense
                      outlined
                      accept="application/pdf, image/png, image/jpeg, image/bmp, application/vnd.ms-excel"
                      @change="handleTroca"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" md="6">
                    <v-file-input
                      label="Enviar anexo"
                      prepend-icon="mdi-file-upload"
                      dense
                      outlined
                      accept="application/pdf, image/png, image/jpeg, image/bmp, application/vnd.ms-excel"
                      @change="handleUpload"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo && fileNovo"
                @click="clearUpload"
              >
                Remover anexo
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="mode === 'novo' || fileNovo"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="mode === 'edit' && !fileNovo"
                @click="updateAnexo()"
              >
                <v-icon left>
                  mdi-update
                </v-icon>
                update
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Modal de confirmação -->
      <v-dialog v-model="dialogRmAnexo" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar remoção
          </v-card-title>

          <v-card-text>
            Tem certeza de que deseja remover este anexo?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="dialogRmAnexo = false">
              Cancelar
            </v-btn>

            <v-btn color="red" text @click="removeAnexoConfirmado">
              Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import axios from 'axios'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import moment from 'moment'
import Vue from 'vue'
const { cpf } = require('cpf-cnpj-validator')
Vue.directive('money', {
  inserted (el, binding) {
    const amount = parseFloat(el.innerHTML).toFixed(2)
      .replace('.', ',')
      //    .replace(/(\d)(?=(\d{3})+,)/g, '$1.')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    el.innerHTML = `${binding.value} ${amount}`
  }
})
export default {
  name: 'Pedidos',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: ' #',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    blokData: false,
    dta: '##/##/####',
    dta1: '##/##/####',
    date0: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_resp: '',
    data_conc: '',
    btnSave: false,
    btnUpdate: false,
    isReloadingPedido: false,
    respondido: false,
    finalizado: false,
    cpf: '###.###.###-##',
    color: 'null',
    menu0: false,
    menu1: false,
    menuL: false,
    codigo: '',
    codepessoa: '',
    coduuid: '',
    tabs: 0,
    uuid: '',
    mode: 'save',
    modef: 'savef',
    DialogAnexo: false,
    loading: false,
    uploadReady: true,
    dialogRmAnexo: false,
    anexoSelecionado: null,
    anexoRemover: null,
    file: null,
    fileNovo: null,
    tabela: 'esicanexos',
    isValid: false,
    btnAction: '',
    btnImprimir: '',
    valid: true,
    dialog: false,
    dialogPessoa: false,
    addHistorico: false,
    total: 0,
    resposta: {},
    conclusao: {},
    pedido: {},
    analisar: {},
    atualizacao: {},
    anexo: {},
    pessoa: {},
    pessoacpf: {},
    items: [],
    pessoas: [],
    solicitacoes: [],
    movimentacao: [],
    orgaos: [],
    status: [],
    filtro: [],
    search: null,
    filtros: null,
    select: null,
    ftpessoa: null,
    veiculos: [
      { value: 1, text: 'Presencial ou carta' },
      { value: 2, text: 'Sistema' },
      { value: 3, text: 'Por telefone' }
    ],
    statusEnd: [
      { value: 4, text: 'Deferido' },
      { value: 5, text: 'Indeferido' },
      { value: 6, text: 'Respondido' }
    ],
    headersFt: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Módulo', value: 'ds_categoria' },
      { text: 'Solicitante', value: 'solicitante' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Data do pedido', value: 'dataP' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFtPessoa: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome/ Razão', value: 'nome' },
      { text: 'Cpf / Cnpj', value: 'cgc-txt' },
      { text: 'NIS', value: 'nis' },
      { text: 'E-mail', value: 'amail' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    historico: {},
    historicos: [],
    headersHistorico: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Descrição', value: 'ds_historico' },
      { text: 'Data', value: 'dataP' },
      { text: 'P. esclarecimento', value: 'chat' },
      { text: 'Respondido', value: 'respondido' },
      { text: 'Movimentação', value: 'movimentacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    anexos: [],
    headersAnexo: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome do arquivo', value: 'nome', sortable: true },
      { text: 'Tabela.', value: 'tabela' },
      { text: 'Pasta', value: 'pasta' },
      { text: 'Subpasta', value: 'subpasta' },
      { text: 'Data', value: 'dataP' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    estadoCivil: [
      { value: 'Solteiro', text: 'Solteiro' },
      { value: 'Casado', text: 'Casado' },
      { value: 'Divorciado', text: 'Divorciado' },
      { value: 'Viúvo', text: 'Viúvo' }
    ],
    tipo: [
      { value: 1, text: 'Documento como foto' },
      { value: 2, text: 'Documento tipo PDF' },
      { value: 3, text: 'Documento tipo msWord' }
    ],
    respostas: [
      { value: 'sistema', text: 'Pelo sistema(sem custo)' },
      { value: 'email', text: 'Por e-mail(sem custo)' },
      { value: 'carta', text: 'Por carta(com custo de postagem)' }
    ],
    categorias: [
      { value: 47, text: 'Sic' },
      { value: 48, text: 'Ouvidoria' }
    ],
    urlRel: ''
  }),
  watch: {
    pedido: {
      handler () {
        // Só muda de aba se foi um reload intencional
        if (this.isReloadingPedido) {
          this.tabs = 0
          this.btnUpdate = false
          this.isReloadingPedido = false
        }
      },
      deep: true
    },

    ftpessoa (val) {
      val && val !== this.filtros && this.querySelectionsAutor(val)
    }
  },

  methods: {
    querySelectionsAutor (v) {
      const fpessoa = v || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${fpessoa}`
      axios.get(url).then(res => {
        this.items = res.data.map(item => {
          return {
            value: item.uid_pessoa,
            text: item.razao
          }
        })
      })
    },

    activeBtn () {
      this.btnUpdate = true
    },

    DateA () {
      this.data_resp = moment(this.date0).format('DD/MM/YYYY')
      this.menu0 = false
      this.mudaDataA()
      this.loadResposta()
    },
    mudaDataA () {
      if (!this.data_resp) return
      const data = moment(this.data_resp, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.pedido.data_resposta = data.format('YYYY-MM-DD')
    },
    DateB () {
      this.data_conc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      this.mudaDataB()
    },
    mudaDataB () {
      if (!this.data_conc) return
      const data = moment(this.data_conc, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.pedido.data_conclusao = data.format('YYYY-MM-DD')
    },

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    save () {
      const method = this.pedido.id ? 'put' : 'post'
      const id = this.pedido.id ? `/${this.pedido.id}` : ''
      axios[method](`${baseApiUrl}/demandas${id}`, this.pedido)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
          this.loadUpPedido()
        })
        .catch(showError)
    },
    async updateObs () {
      const method = 'put'
      const id = `/${this.pedido.id}`
      this.atualizacao.observacao = this.pedido.observacao
      this.atualizacao.usuario = this.user.id
      await axios[method](`${baseApiUrl}/demandas${id}`, this.atualizacao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.isReloadingPedido = true
          this.atualizacao = {}
          this.loadUpPedido()
        })
        .catch(showError)
    },
    addEmAnalise () {
      const id = this.pedido.id
      this.analisar.uid_situacao = 3
      axios.put(`${baseApiUrl}/esic-pedido-atualize/${id}`, this.analisar)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.pedido = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    EnviaPAnalise () {
      const id = this.pedido.id
      this.analisar.uid_situacao = 2
      this.analisar.ds_historico = 'Aguardando análise'
      this.analisar.inativar = 0
      axios.put(`${baseApiUrl}/esic-pedido-atualize/${id}`, this.analisar)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.pedido = {}
          this.analisar = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    addResposta () {
      const id = this.pedido.id
      this.resposta.resposta = this.pedido.resposta
      this.resposta.data_resposta = this.pedido.data_resposta
      this.resposta.respondido = this.pedido.respondido
      this.resposta.ds_historico = 'Sua solicitação foi respondida, verifique na sessão resposta'
      this.resposta.movimentacao = 'Pedido respondido'
      axios.put(`${baseApiUrl}/esic-resposta-e-finalizacao/${id}`, this.resposta)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.pedido = {}
          this.resposta = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    addFinalizar () {
      const id = this.pedido.id
      this.conclusao.data_conclusao = this.pedido.data_conclusao
      this.conclusao.concluido = this.pedido.concluido
      this.conclusao.uid_situacao = this.pedido.uid_situacao
      this.conclusao.ds_historico = 'Sua solicitação foi concluida, verifique na sessão resposta'
      this.conclusao.movimentacao = 'Pedido concluido'
      axios.put(`${baseApiUrl}/esic-resposta-e-finalizacao/${id}`, this.conclusao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.pedido = {}
          this.conclusao = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    saveHistorico () {
      const method = this.historico.id ? 'put' : 'post'
      const id = this.historico.id ? `/${this.historico.id}` : ''
      axios[method](`${baseApiUrl}/historico${id}`, this.historico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparHistorico()
          this.loadHistoricos()
          this.modef = ''
        })
        .catch(showError)
    },
    upCpf () {
      const method = 'put'
      const id = `/${this.pedido.id}`
      axios[method](`${baseApiUrl}/solicitante-cpf${id}`, this.pessoacpf)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetcpf()
        })
        .catch(showError)
    },
    formataCpf () {
      const cpff = this.pessoacpf.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      if (ccpf === true) {
        this.pessoacpf.cgc = number
        this.color = `border: solid 1px #ced4da;`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px red !important;`
      }
    },
    baixarArquivo () {
      window.open(this.urlAnexo, '_blank')
    },
    abrirInputTroca () {
      this.$refs.fileTroca.click()
    },
    handleTroca (e) {
      const file = e.target.files[0]
      if (file) {
        // this.mode = 'save'
        this.fileNovo = file
        this.file = file
        this.uploadReady = true
      }
    },
    handleUpload (file) {
      this.file = file
    },
    async fileUpload () {
      if (!this.file) {
        this.$toasted.global.defaultError('Selecione um arquivo')
        return
      }
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/anexos-da-demanda${id}`
      formData.append('idDemanda', this.pedido.id)
      formData.append('tipo', this.anexo.tipo)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    resetUpload () {
      this.file = null
      this.fileNovo = null
      this.anexo = {}
      if (this.$refs.fileTroca) this.$refs.fileTroca.value = null
    },
    clearUpload () {
      this.uploadReady = false
      this.file = null
      this.fileNovo = null
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    updateAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      this.anexo.tabela = this.tabela
      axios[method](`${baseApiUrl}/anexos-do-portal${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.FecharDialog()
          this.loadAnexos()
        })
        .catch(showError)
    },
    confirmRemove (item) {
      this.anexoSelecionado = item || this.anexo
      this.dialogRmAnexo = true
    },
    removeAnexoConfirmado () {
      const id = this.anexoRemover || this.anexoSelecionado.id
      this.anexo.tabela = this.anexoSelecionado.tabela
      const tabela = this.anexoSelecionado.tabela
      axios.delete(`${baseApiUrl}/anexos-da-demanda/${id}`, {
        params: { tabela }
      })
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
        })
        .catch(showError)
        .finally(() => {
          this.dialogRmAnexo = false
          this.anexoSelecionado = null
          this.anexoRemover = null
        })
    },
    reset () {
      this.pedido = {}
      this.historico = {}
      this.historicos = []
      this.anexos = []
      this.data_resp = ''
      this.data_conc = ''
      this.codigo = ''
      this.coduuid = ''
      this.isValid = false
      this.btnUpdate = false
      this.respondido = false
      this.concluido = false
      this.conclusao = {}
      this.resposta = {}
      this.pedido.usuario = this.user.id
      this.pessoa.razao = ''
      this.loadDatas()
      this.btnAction = ''
      this.btnImprimir = ''
      this.blokData = false
      this.mode = 'save'
    },
    resetcpf () {
      this.pessoacpf = {}
      this.btnSave = false
      this.color = false
      this.reset()
    },
    limparHistorico () {
      this.valid = false
      this.modef = 'savef'
      this.historico = {}
      this.historico.usuario = this.user.id
      this.historico.uid_demanda = this.pedido.id
    },
    loadFiltro () {
      const url = `${baseApiUrl}/esic-pedido-filtro`
      axios.get(url).then(res => {
        this.filtro = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm'),
            solicitante: item.Idp === null ? 'Pedido anônomo' : item.nome
          }
        })
      })
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadPedidoFilter (filtro, mode = 'edit') {
      this.codigo = filtro.id
      this.coduuid = filtro.id
      const id = filtro.id
      const cat = filtro.uid_categoria
      const idRel = filtro.id
      this.pessoacpf.cgc = filtro.cgc
      this.pessoacpf.cgc_txt = filtro.cgc_txt
      this.mode = mode
      this.urlRel = `${baseApiUrl}/rel-pedido-por-id/${idRel}`
      const url = `${baseApiUrl}/esic-pedido-update/${id}`
      axios.get(url).then(res => {
        this.pedido = res.data
        this.pessoacpf.upcpf = this.pedido.upcpf
        this.pessoacpf.conta = this.pedido.conta
        this.respondido = Boolean(Number(this.pedido.respondido))
        this.concluido = Boolean(Number(this.pedido.concluido))
        this.data_resp = moment(this.pedido.data_resposta).format('DD/MM/YYYY')
        this.data_conc = moment(this.pedido.data_conclusao).format('DD/MM/YYYY')
        this.codepessoa = this.pedido.uid_pessoa
        this.dialog = false
        this.valid = true
        this.isReloadingPedido = true
        this.loadTpSolicitacoes(cat)
        this.loadHistoricos()
        this.loadStatus()
        this.loadBtns()
        this.dataUpdate()
        this.formataCpf()
        if (id) {
          this.isValid = true
        }
        this.loadDatas()
      })
    },
    loadPedido (mode = 'edit') {
      const id = this.pedido.id ? `/${this.pedido.id}` : `/${this.coduuid}`
      this.mode = mode
      this.codigo = id
      const url = `${baseApiUrl}/esic-pedido-update${id}`
      axios.get(url).then(res => {
        this.pedido = res.data
        this.respondido = Boolean(Number(this.pedido.respondido))
        this.concluido = Boolean(Number(this.pedido.concluido))
        this.data_resp = moment(this.pedido.data_resposta).format('DD/MM/YYYY')
        this.data_conc = moment(this.pedido.data_conclusao).format('DD/MM/YYYY')
        this.codepessoa = this.pedido.uid_pessoa
        this.isReloadingPedido = true
        this.loadStatus()
        this.loadBtns()
        this.loadDatas()

        this.tabs = 0
      })
      if (id) {
        this.isValid = true
      }
    },

    loadUpPedido (mode = 'edit') {
      this.mode = mode
      const url = `${baseApiUrl}/esic-update-pagina`
      axios.get(url).then(res => {
        this.pedido = res.data
        this.codigo = this.pedido.id
        this.coduuid = this.pedido.id
        this.respondido = Boolean(Number(this.pedido.respondido))
        this.concluido = Boolean(Number(this.pedido.concluido))
        this.data_resp = moment(this.pedido.data_resposta).format('DD/MM/YYYY')
        this.data_conc = moment(this.pedido.data_conclusao).format('DD/MM/YYYY')
        this.codepessoa = this.pedido.uid_pessoa
        this.loadStatus()
        this.loadBtns()
        // this.dataUpdate()
        this.isValid = true
        this.loadDatas()
      })
    },
    loadPessoaId (item) {
      const url = `${baseApiUrl}/pessoas-por-idd/${item.id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.pedido.uid_pessoa = this.pessoa.uid_pessoa
        this.pedido.uuid_pessoa = this.pessoa.uuid_pessoa
        this.pedido.solicitante = this.pessoa.razao
        this.codepessoa = this.pessoa.uid_pessoa
        this.filtros = null
        this.items = []
      })
      this.dialogPessoa = false
    },

    loadPessoaSel () {
      const item = this.filtros
      const id = this.pedido.uid_pessoa ? `/${this.pedido.uid_pessoa}` : `/${item}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.pedido.uid_pessoa = this.pessoa.uid_pessoa
        this.pedido.uuid_pessoa = this.pessoa.uuid_pessoa
        this.pedido.solicitante = this.pessoa.razao
        this.filtros = null
        this.items = []
        this.codepessoa = this.pessoa.uid_pessoa
      })
    },

    loadImprimir (item) {
      const id = item.id
      const url = `${baseApiUrl}/ouvidorias/relatorio-do-historico/${id}?formato=pdf`

      window.open(url, '_blank')
    },

    clPessoa () {
      this.codepessoa = ''
      this.items = []
      this.pedido.uid_pessoa = ''
      this.pedido.solicitante = ''
      this.pessoa = {}
    },
    loadPesoasFilter () {
      const url = `${baseApiUrl}/filtro-pessoas`
      axios.get(url).then(res => {
        this.pessoas = res.data
      })
    },
    loadHistorico (item, modef = 'updateF') {
      const id = item.id
      const url = `${baseApiUrl}/historico-do-pedido-update/${id}`
      axios.get(url).then(res => {
        this.historico = res.data
        this.codigo = this.pedido.id
        this.addHistorico = true
      })
      this.modef = modef
      this.loadMovimentacao()
    },

    loadTpSolicitacoes (cat) {
      let id = cat || this.pedido.uid_categoria
      const url = `${baseApiUrl}/tipo-de-solicitacao-por-categoria/${id}`
      axios.get(url).then(res => {
        this.solicitacoes = res.data.map(solicitacoes => {
          return {
            value: solicitacoes.id,
            text: `${solicitacoes.tipo_solicitacao}`
          }
        })
      })
    },
    loadStatus () {
      const url = `${baseApiUrl}/status-situacoes-cic`
      axios.get(url).then(res => {
        this.status = res.data.map(status => {
          return {
            value: status.id,
            text: `${status.situacao}`
          }
        })
      })
    },
    loadAnexos () {
      const idA = this.pedido.protocolo
      const url = `${baseApiUrl}/anexos-do-pedido/${idA}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm')
          }
        })
      })
    },
    loadHistoricos () {
      const idF = this.pedido.id
      const url = `${baseApiUrl}/historico-do-pedido/${idF}`
      axios.get(url).then(res => {
        this.historicos = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.dt_movimetacao).format('DD/MM/YYYY'),
            chat: item.chat === 0 ? 'Não' : 'Sim',
            respondido: item.respondido === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadOrgaos () {
      const url = `${baseApiUrl}/sic/filtro-orgaos`
      axios.get(url).then(res => {
        this.orgaos = res.data.map(og => {
          return {
            value: og.id,
            text: `${og.orgao}`
          }
        })
      })
    },
    loadMovimentacao () {
      const url = `${baseApiUrl}/movimentacao-dos-processos`
      axios.get(url).then(res => {
        this.movimentacao = res.data.map(mv => {
          return {
            value: mv.ds_movimento,
            text: `${mv.ds_movimento}`
          }
        })
      })
    },
    loadAddHistorico () {
      this.loadMovimentacao()
      this.historico.usuario = this.user.id
      this.historico.uid_demanda = this.pedido.id
      this.addHistorico = true
      this.modef = 'savef'
    },
    loadAddAnexo () {
      this.anexo.uuid = uuid.v1()
      this.anexo.usuario = this.user.id
      this.codigo = this.pedido.id
      this.DialogAnexo = true
      this.mode = 'novo'
    },
    loadAnexo (anexo, mode = 'edit') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.urlAnexo = anexo.url
      this.DialogAnexo = true
    },
    FecharDialog () {
      this.file = null
      this.fileNovo = null
      this.DialogAnexo = false
      this.limpar()
    },
    limpar () {
      this.mode = 'save'
      this.urlAnexo = ''
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.codigo = this.pedido.id
    },
    adicionarHistoricoSave () {
      this.saveHistorico()
    },
    adicionarHistoricoSair () {
      this.saveHistorico()
      this.addHistorico = false
    },
    loadTbHidtorico () {
      this.loadHistoricos()
      this.btnUpdate = false
    },
    loadTbAnexo () {
      this.loadAnexos()
      this.btnUpdate = false
    },
    loadConclusao () {
      this.mode = ''
    },
    loadFtPessoa () {
      this.dialogPessoa = true
      this.loadPesoasFilter()
    },
    loadAddPessoa () {

    },
    loadBtns () {
      const cod = this.codigo
      const sta = this.pedido.uid_situacao
      if (cod) {
        if (sta === 1) {
          this.btnAction = 'enviar'
        } else if (sta === 2) {
          this.btnAction = 'analisar'
        } else if (sta === 3) {
          this.btnAction = 'analisando'
        }
      } else {
        this.btnAction = ''
      }

      if (cod) {
        if (sta >= 2) {
          this.btnImprimir = 'imprimir'
        } else {
          this.btnImprimir = ''
        }
      }

      if ((cod) && sta >= 2) {
        this.blokData = true
        this.mode = 'sincronizar'
      } else {
        this.blokData = false
      }
    },
    loadSaveStatus () {
      const dt = this.pedido.data_conclusao
      const st = this.pedido.uid_situacao
      if (dt || st) {
        this.mode = 'encerrar'
      }
    },
    loadResposta () {
      const dr = this.pedido.data_resposta
      const rs = this.pedido.resposta
      if (dr || rs) {
        this.mode = 'responder'
      }
      this.btnUpdate = false
    },
    loadFinalizar () {
    //   this.date = moment(this.pedido.data_resposta).format('YYYY-MM-DD')
    //   this.data_resposta = moment(this.pedido.data_resposta).format('DD/MM/YYYY')
    //   this.date1 = moment(this.pedido.data_conclusao).format('YYYY-MM-DD')
    //   this.data_conclusao = moment(this.pedido.data_conclusao).format('DD/MM/YYYY')
      this.btnUpdate = false
    },
    dataUpdate () {
      const rs = this.pedido.resposta
      const cl = this.pedido.concluido
      if (rs) {
        // this.pedido.data_resposta = moment(this.pedido.data_resposta).format('YYYY-MM-DD')
      }
      if (cl) {
        // this.pedido.data_conclusao = moment(this.pedido.data_conclusao).format('YYYY-MM-DD')
      }
      this.loadFinalizar()
      console.log('dataUpdate-' + rs)
    },
    loadDatas () {
      this.mudaDataA()
      this.mudaDataB()
    //   const dataAgora = new Date().toISOString().substr(0, 10)
    //   this.data_resposta = moment(dataAgora).format('DD/MM/YYYY')
    //   this.data_conclusao = moment(dataAgora).format('DD/MM/YYYY')
    //   this.date = dataAgora
    //   this.date1 = dataAgora
    },
    loadUser () {
      if (this.user && this.user.id) {
        this.pedido.usuario = this.user.id
      }
    }
  },
  mounted () {
    this.loadUser()
    this.loadOrgaos()
    this.loadBtns()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}

.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}

.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}

.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.logo-foto {
  max-width: 1024px;
}
.botao-container {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #e0f2f1;
  margin-top: -7px !important;
  margin-right: -9px !important;
  padding: 6px 6px;
  border-radius: 6px;
}
</style>
